module.exports = __webpack_public_path__ + "files/bb061c9e69bd92492a36ee2747c8b87b.svg";